export default __webpack_public_path__ + "static/Plots0033-c56193690b18d504cef5e2e9155baff6.jpg";